export default __webpack_public_path__ + "static/media/wbtt.6150b1a4.png";